'use client';

import Image from 'next/image';
import { type JSX } from 'react';

import { DotSpinner } from '../../../_shared/_components/DotSpinner/DotSpinner';

function GlowBackground(): JSX.Element {
    return <div aria-hidden="true" className="absolute -inset-2 rounded-sm blur animate-glow-rotate glow-background" />;
}

type LoadingCardProps = {
    thumbnailUrl?: string;
    thumbnailAlt?: string;
};

export function LoadingCard({ thumbnailUrl, thumbnailAlt = '' }: LoadingCardProps): JSX.Element {
    return (
        <div className="relative w-full">
            <GlowBackground />
            <div className="relative z-10 aspect-video rounded-sm border border-white/20 overflow-hidden bg-black">
                {thumbnailUrl && (
                    <div className="absolute inset-0 bg-black/30">
                        <Image src={thumbnailUrl} alt={thumbnailAlt} fill className="object-contain" />
                    </div>
                )}
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                    <DotSpinner size="large" />
                </div>
            </div>
        </div>
    );
}
